export default __webpack_public_path__ + "static/media/Screenshot_5.a74a6c81.png";